import service from '@/utils/request.js'

//保存小数
function toDecimal(x) {
 var f = parseFloat(x);
 if (isNaN(f)) {
  return;
 }
 f = Math.round(x * 100) / 100;
 return f;
}

//单位转为万
function transformation(x) {
 var f = parseInt(x);
 if (isNaN(f)) {
  return;
 }
 return toDecimal(f /10000)
}

//过滤空字段
function deleteEmptyProperty(obj) {
  var object = obj;
  for (var i in object) {
    var value = object[i];
    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        if (value.length == 0) {
          delete object[i];
          continue;
        }
      }
      deleteEmptyProperty(value);
    } else {
      if (value === '' || value === null || value === undefined) {
        delete object[i];
      }
    }
  }
  return object;
}

function getNowFormatDate() {
  var date = new Date();
  var seperator1 = "/";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate;
  return currentdate;
}

// 上传图片到阿里云
function upLoadOssAliYun(filePath) {
  var timestap = (new Date()).valueOf();
  var suffix = filePath.substr(filePath.lastIndexOf('.'));
  var filename = getNowFormatDate() + "/" + timestap + suffix;
  console.log('filename===>', filename);
  return new Promise(function(resolve, reject) {
      // 异步处理
      // 处理结束后、调用resolve 或 reject
      service.getRequest('/oss/signature', {
        "ossDir": "img"
      }).then(res => {
        let _data = res.data;
        var obsInfo = {
          'obsHost': _data.host,
          'obsData': {
            name: filePath,
            key: "img/" + filename,
            policy: _data.policy,
            OSSAccessKeyId: _data.accessid,
            signature: _data.signature,
            success_action_status: "200",
          },
          'filename': filename
        }
        resolve(obsInfo)
      })
  });

}

/**
 * 获取图片临时访问路径：用于查看
 */
function getImageUrl(_filename){
	return new Promise((resolve, reject) => {
		service.getRequest(`/common/oss/getTempUrl`, { objectName: _filename }).then(res => {
			resolve(res.data)
		})
	})
}

/**
 * 导出,入参是字节流
 */
function downloadFile(data, filename = '未命名文件'){
  // 创建Blob对象并生成下载链接
  const blob = new Blob([data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const url = window.URL.createObjectURL(blob);

  // 创建隐藏的可下载链接
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';

  // 触发下载并清理资源
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export default{
  toDecimal,
  transformation,
  deleteEmptyProperty,
  upLoadOssAliYun,
  getImageUrl,
  downloadFile
}



// WEBPACK FOOTER //
// ./src/utils/util.js